import { useQuery, useQueryClient } from 'react-query'
import axios from '../../utils/axios'
import { API_BASE_URL } from '../../constants'

const fetchCarrierConfigs = async () => {
  const { data } = await axios.get(`${API_BASE_URL}/carrier-analysis-configs/`)
  return data
}

export const useCarrierConfigs = () => {
  const queryClient = useQueryClient()
  const query = useQuery(['carrier-configs'], fetchCarrierConfigs, {
    refetchOnWindowFocus: false,
  })
  const refresh = () => queryClient.invalidateQueries('carrier-configs')
  return { query, refresh }
}
